/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getNutrtiontags } from 'app/entities/nutrtiontags/nutrtiontags.reducer';
import { getEntities as getRecipes } from 'app/entities/recipe/recipe.reducer';
import { createEntity, getEntity, reset, updateEntity } from './recipe-tags.reducer';

export const RecipeTagsUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const nutrtiontags = useAppSelector(state => state.nutrtiontags.entities);
  const recipes = useAppSelector(state => state.recipe.entities);
  const recipeTagsEntity = useAppSelector(state => state.recipeTags.entity);
  const loading = useAppSelector(state => state.recipeTags.loading);
  const updating = useAppSelector(state => state.recipeTags.updating);
  const updateSuccess = useAppSelector(state => state.recipeTags.updateSuccess);

  const handleClose = () => {
    navigate(`/recipe-tags${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getNutrtiontags({}));
    dispatch(getRecipes({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }

    const entity = {
      ...recipeTagsEntity,
      ...values,
      tag: nutrtiontags.find(it => it.id.toString() === values.tag?.toString()),
      recipe: recipes.find(it => it.id.toString() === values.recipe?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...recipeTagsEntity,
          tag: recipeTagsEntity?.tag?.id,
          recipe: recipeTagsEntity?.recipe?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.recipeTags.home.createOrEditLabel" data-cy="RecipeTagsCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.recipeTags.home.createOrEditLabel">Create or edit a RecipeTags</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="recipe-tags-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                id="recipe-tags-tag"
                name="tag"
                data-cy="tag"
                label={translate('tinyMedicRestApp.recipeTags.tag')}
                type="select"
                required
              >
                <option value="" key="0" />
                {nutrtiontags
                  ? nutrtiontags.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="recipe-tags-recipe"
                name="recipe"
                data-cy="recipe"
                label={translate('tinyMedicRestApp.recipeTags.recipe')}
                type="select"
                required
              >
                <option value="" key="0" />
                {recipes
                  ? recipes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/recipe-tags" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default RecipeTagsUpdate;
